import { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface DocumentPdfPreviewDialogProps {
  open: boolean;
  title: string;
  blobUrl: string | null;
  onOpenChange: (open: boolean) => void;
}

export function DocumentPdfPreviewDialog({
  open,
  title,
  blobUrl,
  onOpenChange,
}: DocumentPdfPreviewDialogProps): JSX.Element {
  useEffect(() => {
    if (!open && blobUrl) {
      URL.revokeObjectURL(blobUrl);
    }
  }, [open, blobUrl]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] flex flex-col gap-3 p-4">
        <DialogHeader className="shrink-0">
          <DialogTitle className="text-base">{title}</DialogTitle>
        </DialogHeader>
        {blobUrl ? (
          <iframe
            src={blobUrl}
            title={title}
            className="w-full flex-1 min-h-0 rounded-md border border-border/60 bg-muted/20"
          />
        ) : (
          <div className="flex flex-1 items-center justify-center text-sm text-muted-foreground">
            —
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
